/* eslint-disable @typescript-eslint/no-unused-vars */
import MainDashboardLayout from 'components/Dashboards/MainDashboardLayout';
import PageContentLayout from 'layouts/PageContentLayout';
import React, { useEffect, useState } from 'react';
import PageLayout from '../../../layouts/PageLayout';
import { Alert, Snackbar } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import TitleAndActionSummaryBar from 'components/SummaryBars/TitleAndActionSummaryBar';
export default function DashboardPage() {
  const [summaryBar, setSummaryBar] = useState(<></>);
  const [isLoading, setIsLoading] = useState(false);
  const [tabAction, setTabAction] = useState<JSX.Element>();
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedDashboardId, setSelectedDashboardId] = useState(0);
  const [selectedDashboardName, setSelectedDashboardName] = useState<string>('');
  const [searchParams, setSearchParams] = useSearchParams();

  const id = React.useMemo(() => {
    const t = searchParams.get('id') ?? '';
    if (t) {
      setSelectedDashboardId(+t);
    }
    return t;
  }, [searchParams]);

  const editMode = React.useMemo(() => {
    const t = searchParams.get('editMode') ?? '';
    if (t) {
      return t.toLowerCase() === 'true';
    }
    return false;
  }, [searchParams]);

  useEffect(() => {
    const reportsLink = (
      <Link
        to={`/reporting/dashboard-list`}
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        {' '}
        Dashboards{' '}
      </Link>
    );

    const title = (
      <>
        {'Reporting >  '} {reportsLink} {'  > '} {selectedDashboardName}
      </>
    );
    const tabTitle = `Reporting > Dashboards > Reporting > ${selectedDashboardName}`;
    const summaryBar = (
      <TitleAndActionSummaryBar
        title={title}
        browserTabTitle={tabTitle}
        action={tabAction ?? <></>}
      />
    );
    setSummaryBar && setSummaryBar(summaryBar);
  }, [tabAction, selectedDashboardName]);

  return (
    <PageLayout SummaryBar={summaryBar}>
      <Snackbar
        open={errorMessage !== ''}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={() => setErrorMessage('')}
      >
        <Alert severity="error" onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <PageContentLayout showLoading={isLoading}>
        <MainDashboardLayout
          homeDashboard={false}
          loadingHandler={setIsLoading}
          errorHandler={setErrorMessage}
          setActionHandler={setTabAction}
          selectedDashboardId={selectedDashboardId}
          setDashboardNameHandler={setSelectedDashboardName}
          editMode={editMode}
        />
      </PageContentLayout>
    </PageLayout>
  );
}
